import { render, staticRenderFns } from "./IncOrderType.vue?vue&type=template&id=2188e8e8"
import script from "./IncOrderType.vue?vue&type=script&lang=js"
export * from "./IncOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports